if (!customElements.get('lusso-product-rail')) {
  customElements.define('lusso-product-rail', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-rail-track]');
      this.previous = this.querySelector('[data-rail-prev]');
      this.next = this.querySelector('[data-rail-next]');
      if (!this.track || !this.previous || !this.next) return;
      this.events = new AbortController();
      const signal = this.events.signal;
      const update = () => {
        const position = Math.abs(this.track.scrollLeft);
        this.previous.disabled = position < 2;
        this.next.disabled = position >= this.track.scrollWidth - this.track.clientWidth - 2;
      };
      const move = direction => {
        const rtl = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
        this.track.scrollBy({left: direction * rtl * this.track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      };
      this.previous.addEventListener('click', () => move(-1), {signal});
      this.next.addEventListener('click', () => move(1), {signal});
      this.track.addEventListener('scroll', update, {signal, passive:true});
      this.resize = new ResizeObserver(update);
      this.resize.observe(this.track);
      this.mutations = new MutationObserver(update);
      this.mutations.observe(this.track, {childList:true});
      update();
    }
    disconnectedCallback() {
      this.events?.abort();
      this.resize?.disconnect();
      this.mutations?.disconnect();
    }
  });
}
